export default __webpack_public_path__ + "static/media/AndriyM280.bd6b55e0.jpg";